import { Select as RSelect } from "radix-ui";

import { Icon } from "../icons";
import styles from "./Select.module.css";
import { cx } from "../lib/cx";

export type SelectOption = {
  readonly label: string;
  readonly value: string;
};

export type SelectProps = {
  readonly className?: string;
  readonly disabled?: boolean;
  readonly onValueChange: (value: string) => void;
  readonly options: ReadonlyArray<SelectOption>;
  readonly value: string;
};

export const Select = ({
  className,
  disabled,
  onValueChange,
  options,
  value,
}: SelectProps) => (
  <RSelect.Root disabled={disabled} onValueChange={onValueChange} value={value}>
    <RSelect.Trigger className={cx(styles.trigger, className)}>
      <RSelect.Value />
      <RSelect.Icon className={styles.icon}>
        <Icon.ChevDown size={13} />
      </RSelect.Icon>
    </RSelect.Trigger>
    <RSelect.Portal>
      <RSelect.Content
        className={styles.content}
        position="popper"
        sideOffset={4}
      >
        <RSelect.Viewport>
          {options.map((o) => (
            <RSelect.Item className={styles.item} key={o.value} value={o.value}>
              <RSelect.ItemText>{o.label}</RSelect.ItemText>
            </RSelect.Item>
          ))}
        </RSelect.Viewport>
      </RSelect.Content>
    </RSelect.Portal>
  </RSelect.Root>
);
